import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import {
  Wrapper,
  Title,
  Subtitle,
  LinkToHome,
  ContainerHero,
  Hero404,
} from "./styled"

const Page404 = () => {
  const { image404 } = useStaticQuery(
    graphql`
      query {
        image404: file(relativePath: { eq: "hero-404.png" }) {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    `
  )

  return (
    <Wrapper>
      <Title>Uuups... página não encontrada :(</Title>
      <Subtitle>
        Tá perdido(a)? Volte para a <LinkToHome href="/">home</LinkToHome>.
      </Subtitle>
      <ContainerHero>
        <Hero404 fluid={image404.childImageSharp.fluid} />
      </ContainerHero>
    </Wrapper>
  )
}

export default Page404
